
import perfectedDrinks from '../img/PerfectedDrinks2025.png';



import icedHolyBasilDawa from '../img/Drink/2025/Squre/1.png';
import icedHolyBasilDawaRect from '../img/Drink/2025/Rect/1.png';

import icedMintDawa from '../img/Drink/2025/Squre/2.png';
import icedMintDawaRect from '../img/Drink/2025/Rect/2.png';

import icedMintDawa1 from '../img/Drink/icedMintDawa1.png';
import icedMintDawa1Rect from '../img/Drink/icedMintDawa1Rect.png';

import icedCinnamonGarlicDawa from '../img/Drink/2025/Squre/3.png';
import icedCinnamonGarlicDawa1 from '../img/Drink/icedCinnamonGarlicDawa1.png';
import icedCinnamonGarlicDawa1Rect from '../img/Drink/icedCinnamonGarlicDawa1Rect.png';
import icedCinnamonGarlicDawaRect from '../img/Drink/2025/Rect/3.png'

import icedClassicDawa from '../img/Drink/2025/Squre/4.png';
import icedClassicDawa1 from '../img/Drink/icedClassicDawa1.png';
import icedClassicDawaRect from '../img/Drink/2025/Rect/4.png'
import icedClassicDawa1Rect from '../img/Drink/icedClassicDawa1Rect.png'

import cinnamonGarlicDawa from '../img/Drink/2025/Squre/5.png';
import cinnamonGarlicDawaRect from '../img/Drink/2025/Rect/5.png';

import classicDawa from '../img/Drink/2025/Squre/6.png';
import classicDawaRect from '../img/Drink/2025/Rect/6.png'

import mintDawa from '../img/Drink/2025/Squre/7.png';
import mintDawaRect from '../img/Drink/2025/Rect/7.png'

import holyBasilDawa from '../img/Drink/2025/Squre/8.png';
import holyBasilDawaRect from '../img/Drink/2025/Rect/8.png'

import redVelvetMilkshake from '../img/Drink/redVelvetMilkshake.png';
import redVelvetMilkshakeRect from '../img/Drink/redVelvetMilkshakeRect.png';
import blueberryMilkshake from '../img/Drink/blueberryMilkshake.png';
import blueberryMilkshakeRect from '../img/Drink/blueberryMilkshakeRect.png';
import peanutButterChocolateMilkshake from '../img/Drink/peanutButterChocolateMilkshake.png';
import peanutButterChocolateMilkshakeRect from '../img/Drink/peanutButterChocolateMilkshakeRect.png';
import gingerCookieMilkshake from '../img/Drink/gingerCookieMilkshake.png';
import gingerCookieMilkshakeRect from '../img/Drink/gingerCookieMilkshakeRect.png';

import caramelMochaMilkshake from '../img/Drink/caramelMochaMilkshake.png';
import caramelMochaMilkshakeRect from '../img/Drink/caramelMochaMilkshakeRect.png';

import oreoMilkshake from '../img/Drink/oreoMilkshake.png';
import oreoMilkshakeRect from '../img/Drink/oreoMilkshakeRect.png';
import cjsMochaMilkshake from '../img/Drink/cjsMochaMilkshake.png';
import cjsMochaMilkshakeRect from '../img/Drink/cjsMochaMilkshakeRect.png';
import caramelMilkshake from '../img/Drink/caramelMilkshake.png';
import caramelMilkshakeRect from '../img/Drink/caramelMilkshakeRect.png';
import brownieMilkshake from '../img/Drink/brownieMilkshake.png';
import brownieMilkshakeRect from '../img/Drink/brownieMilkshakeRect.png';
import strawberryMilkshake from '../img/Drink/strawberryMilkshake.png';
import strawberryMilkshakeRect from '../img/Drink/strawberryMilkshakeRect.png';

import chocolateMilkshake from '../img/Drink/chocolateMilkshake.png';
import chocolateMilkshakeRect from '../img/Drink/chocolateMilkshakeRect.png';
import vanillaClassicMilkshake from '../img/Drink/vanillaClassicMilkshake.png';
import vanillaClassicMilkshakeRect from '../img/Drink/vanillaClassicMilkshakeRect.png';
import classicTropical from '../img/Drink/classicTropical.png';
import classicTropicalRect from '../img/Drink/classicTropicalRect.png';

import strawberrySmoothie from '../img/Drink/strawberrySmoothie.png';
import strawberrySmoothieRect from '../img/Drink/strawberrySmoothieRect.png';
import tropicalSmoothie from '../img/Drink/tropicalSmoothie.png';
import tropicalSmoothieRect from '../img/Drink/tropicalSmoothieRect.png';
import veryBerrySmoothie from '../img/Drink/veryBerrySmoothie.png';
import veryBerrySmoothieRect from '../img/Drink/veryBerrySmoothieRect.png';
import peanutButterSmoothie from '../img/Drink/peanutButterSmoothie.png';
import peanutButterSmoothieRect from '../img/Drink/peanutButterSmoothieRect.png';
import cjsDateBooster from '../img/Drink/cjsDateBooster.png';
import cjsDateBoosterRect from '../img/Drink/cjsDateBoosterRect.png';
import aloha from '../img/Drink/aloha.png';
import alohaRect from '../img/Drink/alohaRect.png';
import mangoMadness from '../img/Drink/mangoMadness.png';
import mangoMadnessRect from '../img/Drink/mangoMadnessRect.png';

import turmericTwist from '../img/Drink/turmericTwist.png';
import turmericTwistRect from '../img/Drink/turmericTwistRect.png';
import cjsBoost from '../img/Drink/cjsBoost.png';
import cjsBoostRect from '../img/Drink/cjsBoostRect.png';
import orangeJuice from '../img/Drink/orangeJuice.png';
import orangeJuiceRect from '../img/Drink/orangeJuiceRect.png';
import orangeCarrotJuice from '../img/Drink/orangeCarrotJuice.png';
import orangeCarrotJuiceRect from '../img/Drink/orangeCarrotJuiceRect.png';

import pineappleMintJuice from '../img/Drink/pineappleMintJuice.png';
import pineappleMintJuiceRect from '../img/Drink/pineappleMintJuiceRect.png';
import beetrootMangoCarrotJuice from '../img/Drink/beetrootMangoCarrotJuice.png';
import beetrootMangoCarrotJuiceRect from '../img/Drink/beetrootMangoCarrotJuiceRect.png';
import pineappleJuiceRect from '../img/Drink/pineappleJuiceRect.png';
import pineappleJuice from '../img/Drink/PineappleJuiceNew.png';

import mangoJuice from '../img/Drink/MangoJuiseNew.png';
import mangoJuiceRect from '../img/Drink/MangoJuiseRectangle.png';
import passionJuice from '../img/Drink/passionJuice.png';
import passionJuiceRect from '../img/Drink/passionJuiceRect.png';
import watermelonJuice from '../img/Drink/watermelonJuice.png';
import watermelonJuiceRect from '../img/Drink/watermelonJuiceRect.png';
import carrotJuice from '../img/Drink/CarrotJuiceNew.png';
import carrotJuiceRect from '../img/Drink/carrotJuiceRect.png';
import beetrootJuice from '../img/Drink/beetrootJuice.png';
import beetrootJuiceRect from '../img/Drink/beetrootJuiceRect.png';
import cocktailJuice from '../img/Drink/cocktailJuice.png';
import cocktailJuiceRect from '../img/Drink/cocktailJuiceRect.png';

import berryVanilla from '../img/Drink/berryVanilla.png';
import berryVanillaRect from '../img/Drink/berryVanillaRect.png';
import passionIcedTea from '../img/Drink/passionIcedTea.png';
import passionIcedTeaRect from '../img/Drink/passionIcedTeaRect.png';
import peachIcedTea from '../img/Drink/peachIcedTea.png';
import peachIcedTeaRect from '../img/Drink/peachIcedTeaRect.png';
import kiwiIcedTea from '../img/Drink/kiwiIcedTea.png';
import kiwiIcedTeaRect from '../img/Drink/kiwiIcedTeaRect.png';
import strawberryIcedTea from '../img/Drink/strawberryIcedTea.png';
import strawberryIcedTeaRect from '../img/Drink/strawberryIcedTeaRect.png';
import lemonIcedTea from '../img/Drink/lemonIcedTea.png';
import lemonIcedTeaRect from '../img/Drink/lemonIcedTeaRect.png';
import blueLagoon from '../img/Drink/blueLagoon.png';
import blueLagoonRect from '../img/Drink/blueLagoonRect.png';
import kiwiLemonade from '../img/Drink/kiwiLemonade.png';
import kiwiLemonadeRect from '../img/Drink/kiwiLemonadeRect.png';
import strawberryLemonade from '../img/Drink/strawberryLemonade.png';
import strawberryLemonadeRect from '../img/Drink/strawberryLemonadeRect.png';
import peachLemonade from '../img/Drink/peachLemonade.png';
import peachLemonadeRect from '../img/Drink/peachLemonadeRect.png';
import classicLemonade from '../img/Drink/classicLemonade.png';
import classicLemonadeRect from '../img/Drink/classicLemonadeRect.png';
import pinaColada from '../img/Drink/pinaColada.png';
import pinaColadaRect from '../img/Drink/pinaColadaRect.png';
import strawberryColada from '../img/Drink/strawberryColada.png';
import strawberryColadaRect from '../img/Drink/strawberryColadaRect.png';
import passionColada from '../img/Drink/passionColada.png';
import passionColadaRect from '../img/Drink/passionColadaRect.png';
import peachColada from '../img/Drink/peachColada.png';
import peachColadaRect from '../img/Drink/peachColadaRect.png';

import classicNojito from '../img/Drink/classicNojito.png';
import classicNojito1 from '../img/Drink/classicNojito1.png';
import classicNojitoRect from '../img/Drink/classicNojitoRect.png';
import classicNojito1Rect from '../img/Drink/classicNojito1Rect.png';
import passionNojito from '../img/Drink/passionNojito.png';
import passionNojitoRect from '../img/Drink/passionNojitoRect.png';
import strawberryNojito from '../img/Drink/strawberryNojito.png';
import strawberryNojitoRect from '../img/Drink/strawberryNojitoRect.png';
import kiwiNojito from '../img/Drink/kiwiNojito.png';
import kiwiNojitoRect from '../img/Drink/kiwiNojitoRect.png';
import strawberryPeachPassionFuse from '../img/Drink/strawberryPeachPassionFuse.png';
import strawberryPeachPassionFuseRect from '../img/Drink/strawberryPeachPassionFuseRect.png';

import hotChocolate from '../img/Drink/hotChocolate.png';
import hotChocolateRect from '../img/Drink/hotChocolateRect.png';

import iceChocolate from '../img/Drink/IceChocolateSqure2025.png';
import iceChocolateRect from '../img/Drink/IceChocolateRect2025.png';
import africanTeaPot from '../img/Drink/africanTeaPot.png';
import africanTeaPotRect from '../img/Drink/africanTeaPotRect.png';
import englishTea from '../img/Drink/englishTea.png';
import englishTeaRect from '../img/Drink/englishTeaRect.png';
import blackTeaPot from '../img/Drink/blackTeaPot.png';
import blackTeaPotRect from '../img/Drink/blackTeaPotRect.png';
import herbalTea from '../img/Drink/herbalTea.png';
import herbalTeaRect from '../img/Drink/herbalTeaRect.png';
import lemonTea from '../img/Drink/lemonTea.png';
import lemonTeaRect from '../img/Drink/lemonTeaRect.png';

import icedMocha from '../img/Drink/icedMocha.png';
import icedMochaRect from '../img/Drink/icedMochaRect.png';
import cafeAffogato from '../img/Drink/cafeAffogato.png';
import cafeAffogatoRect from '../img/Drink/cafeAffogatoRect.png';
import icedCaramelMocha from '../img/Drink/IcedCaramelMochaSqure2025.png';
import icedCaramelMochaRect from '../img/Drink/icedCaramelMochaRect.png';
import mocha from '../img/Drink/mocha.png';
import mochaRect from '../img/Drink/mochaRect.png';
import caramelMocha from '../img/Drink/caramelMocha.png';
import caramelMochaRect from '../img/Drink/icedCaramelMochaRect.png';
import icedLatte from '../img/Drink/icedLatte-1.png';
import icecafelatteRect from '../img/Drink/icecafelatteRect.png';
import icedCaramelLatte from '../img/Drink/1.png';
import icedCaramelLatteRect from '../img/Drink/1.png';
import cafelatte1 from '../img/Drink/cafeLatte.png';
import vanillaLatte from '../img/Drink/vanillaLatte.png';
import vanillaLatteRect from '../img/Drink/vanillaLatteRect.png';
import caramelLatte from '../img/Drink/caramelLatte.png';
import caramelLatteRect from '../img/Drink/caramelLatteRect.png';
import spanishLatte from '../img/Drink/spanishLatte.png';
import spanishLatteRect from '../img/Drink/spanishLatteRect.png';
import cappuccino from '../img/Drink/cappuccino.png';
import cappuccinoRect from '../img/Drink/cappuccinoRect.png';
import cardamonGinger from '../img/Drink/cardamonGinger.png';
import cardamonGingerRect from '../img/Drink/cardamonGingerRect.png';

// Drink House Coffee
import houseCoffee from '../img/Drink/houseCoffee.png';
import houseCoffeeRect from '../img/Drink/houseCoffeeRect.png';
import cortadoCoffee from '../img/Drink/cortadoCoffee.png';
import cortadoCoffeeRect from '../img/Drink/cortadoCoffeeRect.png';
import americano from '../img/Drink/americano.png';
import americanoRect from '../img/Drink/americanoRect.png';
import espresso from '../img/Drink/espressoRect.png';
import espressoRect from '../img/Drink/espressoRect.png';
import macchiato from '../img/Drink/macchiato-1.png';
import macchiatoRect from '../img/Drink/macchiatoRect.png';
import icedCoffee from '../img/Drink/icedCoffee.png';
import icedCoffeeRect from '../img/Drink/icedCoffeeRect.png';
import Showoff from '../img/Drink/CjsShowoff.png'
import ShowoffRect from '../img/Drink/CjsShowoffRectangle.png'

import CaramelEspresso from '../img/Drink/classic-tropical-squre.png'
import CaramelEspressorect from '../img/Drink/classic-tropical-rect.png'
import NutellaCookie from '../img/Drink/nutella-cookie-squre.png'
import NutellaCookierect from '../img/Drink/nutella-cookie-rect.png'
import BubbleGum from '../img/Drink/bubble-gum-squre.png'
import BubbleGumrect from '../img/Drink/bubble-gum-rect.png'

import Lavender from '../img/Drink/Lavender-squre.png'
import Lavenderrect from '../img/Drink/Lavender-rect.png'
import CucumberKiwi from '../img/Drink/Cucumber-squre.png'
import CucumberKiwirect from '../img/Drink/Cucumber-rect.png'
import ThaiIcedTea from '../img/Drink/Thai-Iced-squre.png'
import ThaiIcedTeaRect from '../img/Drink/Thai-Iced-rect.png'
import HibiscusIcedTea from '../img/Drink/HibiscusIcedTea.png'
import HibiscusIcedTeaRect from '../img/Drink/HibiscusIcedTeaRect.png'


import CucumberKiwiLemonade from '../img/Drink/cucumber-kiwi-lemonade-squre.png'
import CucumberKiwiLemonaderect from '../img/Drink/cucumber-kiwi-lemonade-rect.png'
import LavenderLemonade from '../img/Drink/lavender-lemonade-rect.png'
import StrawberrySunriseLemonade from '../img/Drink/strawberry-sunrise-lemonade.png'
import StrawberrySunriseLemonadeRect from '../img/Drink/strawberry-sunrise-lemonade-rect.png'
import LavenderLemonaderect from '../img/Drink/lavender-lemonade-rect.png'

import ButterflyPea from '../img/Drink/butterfly-pea-colada-squre.png'
import ButterflyPeaRect from '../img/Drink/butterfly-pea-colada-rect.png'

import CucumberKiwiNojito from '../img/Drink/cucumber-kiwi-nojito-squre.png'
import CucumberKiwiNojitorect from '../img/Drink/cucumber-kiwi-nojito-rect.png'
import HibiscusNojito from '../img/Drink/hibiscus-nojito-squre.png'
import HibiscusNojitoRect from '../img/Drink/hibiscus-nojito-rect.png'
import CocoLeBleuNojito from '../img/Drink/coco-le-bleu-nojito-squre.png'
import CocoLeBleuNojitoRect from '../img/Drink/coco-le-bleu-nojito-rect.png'

import MintAquaCooler from '../img/Drink/mint-aqua-cooler-squre.png'
import MintAquaCoolerRect from '../img/Drink/mint-aqua-cooler-rect.png'
import LavenderNojito from '../img/Drink/lavender-nojito-sure.png'
import LavenderNojitoRect from '../img/Drink/lavender-nojito-rect.png'
import StrawberrySunriseNojito from '../img/Drink/strawberry-sunrise-nojito.png'
import StrawberrySunriseNojitoRect from '../img/Drink/strawberry-sunrise-nojito-rect.png'

import ButterflyPeaInfusionTea from '../img/Drink/butterfly-pea-infusion-tea-squre.png'
import ButterflyPeaInfusionTearect from '../img/Drink/butterfly-pea-infusion-tea-rect.png'
import HibiscusInfusionTea from '../img/Drink/hibiscus-infusion-tea-squre.png'
import HibiscusInfusionTeaRect from '../img/Drink/hibiscus-infusion-tea-rect.png'

import KiddieColada from '../img/Drink/kiddie/kiddieColada.png'
import KiddieColadaRect from '../img/Drink/kiddie/kiddieColadaRect.png'
import KiddieFruitBooster from '../img/Drink/kiddie/kiddieFruitBooster.png'
import kiddieFruitBoosterRect from '../img/Drink/kiddie/kiddieFruitBoosterRect.png'
import kiddieIcedTea from '../img/Drink/kiddie/kiddieIcedTea.png'
import kiddieIcedTeaRect from '../img/Drink/kiddie/kiddieIcedTeaRect.png'
import kiddieJuice from '../img/Drink/kiddie/kiddieJuice.png'
import kiddieJuiceRect from '../img/Drink/kiddie/kiddieJuiceRect.png'
import kiddieLemonade from '../img/Drink/kiddie/kiddieLemonade.png'
import kiddieLemonadeRect from '../img/Drink/kiddie/kiddieLemonadeRect.png'
import kiddieMilkshake from '../img/Drink/kiddie/kiddieMilkshake.png'
import kiddieMilkshakeRect from '../img/Drink/kiddie/kiddieMilkshakeRect.png'
import kiddieNojito from '../img/Drink/kiddie/kiddieNojito.png'
import kiddieNojitoRect from '../img/Drink/kiddie/kiddieNojitoRect.png'

import kiddieOrangeJuice from '../img/Drink/kiddie/Kiddie_Orange_Juice.png'
import kiddieOrangeCarrotJuice from '../img/Drink/kiddie/Kiddie_Orange_Carrot_Juice.png'



const PerfectedDrinks =   {
    "ImageURL":perfectedDrinks,
    "Name":"Perfected Drinks",
    "OpenTime":"06:00 AM - 11:00 PM",
    "Status":"Opened",
    "type":[

          {
            "ImageURL": icedHolyBasilDawa,
            "Name": "Iced Holy Basil Dawa",
            "category": "Dawa Teas",
            "dec": "Your favourite dawa tea served in ice.",
            "KES": 430,
            "RectImageURL": icedHolyBasilDawaRect,
            "Upgrades": []
          },
          {
            "ImageURL": icedMintDawa1,
            "Name": "Iced Mint Dawa",
            "category": "Dawa Teas",
            "dec": "Your favourite dawa tea served in ice.",
            "KES": 430,
            "RectImageURL": icedMintDawa1Rect,
            "Upgrades": []
          },
          {
            "ImageURL": icedCinnamonGarlicDawa1,
            "Name": "Iced Cinnamon Garlic Dawa",
            "category": "Dawa Teas",
            "dec": "Your favourite dawa tea served in ice.",
            "KES": 430,
            "RectImageURL": icedCinnamonGarlicDawa1Rect,
            "Upgrades": []
          },
          {
            "ImageURL": icedClassicDawa1,
            "Name": "Iced Classic Dawa",
            "category": "Dawa Teas",
            "dec": "Your favourite dawa tea served in ice.",
            "KES": 430,
            "RectImageURL": icedClassicDawa1Rect,
            "Upgrades": []
          },
          {
            "ImageURL": cinnamonGarlicDawa,
            "Name": "Cinnamon Garlic Dawa",
            "category": "Dawa Teas",
            "dec": "Mix of fresh ginger, fresh lemon, garlic & cinnamon.",
            "KES": 350,
            "RectImageURL": cinnamonGarlicDawaRect,
            "Upgrades": []
          },
          {
            "ImageURL": classicDawa,
            "Name": "Classic Dawa",
            "category": "Dawa Teas",
            "dec": "Mix of fresh ginger & fresh lemon.",
            "KES": 350,
            "RectImageURL": classicDawaRect,
            "Upgrades": []
          },
          {
            "ImageURL": mintDawa,
            "Name": "Mint Dawa",
            "category": "Dawa Teas",
            "dec": "Mix of fresh ginger, fresh mint & lemon.",
            "KES": 350,
            "RectImageURL": mintDawaRect,
            "Upgrades": []
          },
          {
            "ImageURL": holyBasilDawa,
            "Name": "Holy Basil Dawa",
            "category": "Dawa Teas",
            "dec": "Mix of fresh ginger, fresh & fresh holy basil.",
            "KES": 350,
            "RectImageURL": holyBasilDawaRect,
            "Upgrades": []
          },
          {
            "ImageURL": redVelvetMilkshake,
            "Name": "Red Velvet Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Blend of premium vanilla ice cream, milk & red velvet.",
            "KES": 550,
            "RectImageURL": redVelvetMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
              
            ]
          },
          {
            "ImageURL": blueberryMilkshake,
            "Name": "Blueberry Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Blueberry Milkshake.",
            "KES": 550,
            "RectImageURL": blueberryMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": peanutButterChocolateMilkshake,
            "Name": "Peanut Butter & Chocolate Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Blend of premium vanilla ice cream, peanut butter & chocolate.",
            "KES": 550,
            "RectImageURL": peanutButterChocolateMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": gingerCookieMilkshake,
            "Name": "Ginger Cookie Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Ginger cookie Milkshake.",
            "KES": 550,
            "RectImageURL": gingerCookieMilkshakeRect,
            "Upgrades": [  
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": caramelMochaMilkshake,
            "Name": "Caramel Mocha Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Caramel Mocha Milkshake.",
            "KES": 550,
            "RectImageURL": caramelMochaMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": oreoMilkshake,
            "Name": "Oreo Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Oreo Milkshake.",
            "KES": 550,
            "RectImageURL": oreoMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": cjsMochaMilkshake,
            "Name": "CJ’s Mocha Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Oreo Milkshake.",
            "KES": 550,
            "RectImageURL": cjsMochaMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": caramelMilkshake,
            "Name": "Caramel Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Blend of premium vanilla ice cream, caramel syrup & milk.",
            "KES": 550,
            "RectImageURL": caramelMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": brownieMilkshake,
            "Name": "Brownie Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Blend of premium vanilla ice cream, milk & chocolate brownie.",
            "KES": 550,
            "RectImageURL": brownieMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": strawberryMilkshake,
            "Name": "Strawberry Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Strawberry Milkshake.",
            "KES": 530,
            "RectImageURL": strawberryMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": chocolateMilkshake,
            "Name": "Chocolate Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Chocolate Milkshake.",
            "KES": 530,
            "RectImageURL": chocolateMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": vanillaClassicMilkshake,
            "Name": "Vanilla Classic Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Vanilla classic milkshake.",
            "KES": 530,
            "RectImageURL": vanillaClassicMilkshakeRect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          // {
          //   "ImageURL": classicTropical,
          //   "Name": "Classic Tropical",
          //   "category": "Creamy Milkshakes",
          //   "dec": "Tropical Milkshake.",
          //   "KES": 530,
          //   "RectImageURL": classicTropicalRect,
          //   "Upgrades": [
          //       { name: "Add Whipped cream", price: 100 },
          //       { name: "Add Chocochip", price: 80 }
          //   ]
          // },
          {
            "ImageURL": CaramelEspresso,
            "Name": "Caramel Espresso",
            "category": "Creamy Milkshakes",
            "dec": "Caramel Espresso.",
            "KES": 550,
            "RectImageURL": CaramelEspressorect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": BubbleGum,
            "Name": "Bubble Gum",
            "category": "Creamy Milkshakes",
            "dec": "Bubble Gum",
            "KES": 550,
            "RectImageURL": BubbleGumrect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": NutellaCookie,
            "Name": "Nutella Cookie Milkshake",
            "category": "Creamy Milkshakes",
            "dec": "Nutella Cookie Milkshake",
            "KES": 550,
            "RectImageURL": NutellaCookierect,
            "Upgrades": [
                { name: "Add Whipped cream", price: 100 },
                { name: "Add Chocochip", price: 80 }
            ]
          },
          {
            "ImageURL": strawberrySmoothie,
            "Name": "Strawberry Smoothie",
            "category": "Real Fruit Smoothies",
            "dec": "A blend of premium yogurt & fresh strawberry.",
            "KES": 510,
            "RectImageURL": strawberrySmoothieRect,
            "Upgrades": [
              { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": tropicalSmoothie,
            "Name": "Tropical Smoothie",
            "category": "Real Fruit Smoothies",
            "dec": "A blend of premium yogurt, mango, strawberry, bananas.",
            "KES": 510,
            "RectImageURL": tropicalSmoothieRect,
            "Upgrades": [
              { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": veryBerrySmoothie,
            "Name": "Very Berry Smoothie",
            "category": "Real Fruit Smoothies",
            "dec": "A blend of premium yogurt & mixed berries.",
            "KES": 510,
            "RectImageURL": veryBerrySmoothieRect,
            "Upgrades": [
              { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": peanutButterSmoothie,
            "Name": "Peanut Butter Smoothie",
            "category": "Real Fruit Smoothies",
            "dec": "A blend of premium yogurt, peanut butter & bananas",
            "KES": 510,
            "RectImageURL": peanutButterSmoothieRect,
            "Upgrades": [
              { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": cjsDateBooster,
            "Name": "CJ’s Date Booster",
            "category": "Fruit Boosters",
            "dec": "A smooth blend of Dates, milk, ginger, banana & cinnamon.",
            "KES": 540,
            "RectImageURL": cjsDateBoosterRect,
            "Upgrades": []
          },
          {
            "ImageURL": aloha,
            "Name": "Aloha",
            "category": "Fruit Boosters",
            "dec": "A smooth blend of fresh bananas, pineapples, mangoes with coconut flavor.",
            "KES": 540,
            "RectImageURL": alohaRect,
            "Upgrades": []
          },
          {
            "ImageURL": mangoMadness,
            "Name": "Mango Madness",
            "category": "Fruit Boosters",
            "dec": "A smooth blend of vanilla ice cream, fresh mango juice, fresh bananas, strawberries, and lime juice.",
            "KES": 540,
            "RectImageURL": mangoMadnessRect,
            "Upgrades": []
          },
          {
            "ImageURL": Showoff,
            "Name": "CJ’s Showoff",
            "category": "Fruit Boosters",
            "dec": "Vanilla ice cream, mango juice & banana, strawberries & lime juice",
            "KES": 540,
            "RectImageURL": ShowoffRect,
            "Upgrades": []
          },
          {
            "ImageURL": turmericTwist,
            "Name": "Turmeric Twist",
            "category": "Speciality Juices",
            "dec": "Blend of fruits, ginger & Turmeric mix.",
            "KES": 530,
            "RectImageURL": turmericTwistRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": cjsBoost,
            "Name": "CJ’s Boost",
            "category": "Speciality Juices",
            "dec": "Blend of fruits & beetroot.",
            "KES": 530,
            "RectImageURL": cjsBoostRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": orangeJuice,
            "Name": "Orange Juice",
            "category": "Speciality Juices",
            "dec": "Freshly squeezed orange juice.",
            "KES": 530,
            "RectImageURL": orangeJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": orangeCarrotJuice,
            "Name": "Orange & Carrot Juice",
            "category": "Speciality Juices",
            "dec": "Freshly squeezed orange and carrot juice.",
            "KES": 480,
            "RectImageURL": orangeCarrotJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": pineappleMintJuice,
            "Name": "Pineapple & Mint Juice",
            "category": "Speciality Juices",
            "dec": "A fine blend of fresh pineapple juice and mint leaves.",
            "KES": 380,
            "RectImageURL": pineappleMintJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": beetrootMangoCarrotJuice,
            "Name": "Beetroot, Mango & Carrot Juice",
            "category": "Speciality Juices",
            "dec": "Freshly squeezed beetroot, mango and carrots.",
            "KES": 530,
            "RectImageURL": beetrootMangoCarrotJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": pineappleJuice,
            "Name": "Pineapple Juice",
            "category": "Speciality Juices",
            "dec": "Freshly squeezed pineapples.",
            "KES": 380,
            "RectImageURL": pineappleJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": mangoJuice,
            "Name": "Mango Juice",
            "category": "Speciality Juices",
            "dec": "Fresh blended mango.",
            "KES": 380,
            "RectImageURL": mangoJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": passionJuice,
            "Name": "Passion Juice",
            "category": "Speciality Juices",
            "dec": "Fresh blended passion.",
            "KES": 380,
            "RectImageURL": passionJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": watermelonJuice,
            "Name": "Watermelon Juice",
            "category": "Speciality Juices",
            "dec": "Freshly squeezed watermelon juice.",
            "KES": 380,
            "RectImageURL": watermelonJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": carrotJuice,
            "Name": "Carrot Juice",
            "category": "Speciality Juices",
            "dec": "Freshly blended carrots.",
            "KES": 380,
            "RectImageURL": carrotJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": beetrootJuice,
            "Name": "Beetroot Juice",
            "category": "Speciality Juices",
            "dec": "Freshly pressed beetroots.",
            "KES": 450,
            "RectImageURL": beetrootJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": cocktailJuice,
            "Name": "Cocktail Juice",
            "category": "Speciality Juices",
            "dec": "Watermelon, Mango, Pineapple, Passion.",
            "KES": 380,
            "RectImageURL": cocktailJuiceRect,
            "Upgrades": [
                { name: "Add Mint", price: 100 },
                { name: "Add Ginger", price: 100 },
                { name: "Add Lemon Juice", price: 100 }
            ]
          },
          {
            "ImageURL": berryVanilla,
            "Name": "Berry Vanilla",
            "category": "Refreshing Iced Teas",
            "dec": "Berry Vanilla",
            "KES": 540,
            "RectImageURL": berryVanillaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }
            ]
          },
          {
            "ImageURL": passionIcedTea,
            "Name": "Passion Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Shaken iced cold passion flavored tea mixed with lemon.",
            "KES": 540,
            "RectImageURL": passionIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": peachIcedTea,
            "Name": "Peach Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Shaken iced cold peach flavored tea mixed with lemon.",
            "KES": 540,
            "RectImageURL": peachIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": kiwiIcedTea,
            "Name": "Kiwi Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Shaken iced cold kiwi flavored tea mixed with lemon.",
            "KES": 540,
            "RectImageURL": kiwiIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": strawberryIcedTea,
            "Name": "Strawberry Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Shaken iced cold strawberry flavored tea mixed with lemon.",
            "KES": 540,
            "RectImageURL": strawberryIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": lemonIcedTea,
            "Name": "Lemon Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Shaken iced cold lemon tea",
            "KES": 540,
            "RectImageURL": lemonIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": Lavender,
            "Name": "Lavender Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Lavender Iced Tea",
            "KES": 540,
            "RectImageURL": Lavenderrect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": CucumberKiwi,
            "Name": "Cucumber Kiwi Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Cucumber Kiwi Iced Tea",
            "KES": 540,
            "RectImageURL": CucumberKiwirect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": ThaiIcedTea,
            "Name": "Thai Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Thai Iced Tea.",
            "KES": 540,
            "RectImageURL": ThaiIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": HibiscusIcedTea,
            "Name": "Hibiscus Iced Tea",
            "category": "Refreshing Iced Teas",
            "dec": "Hibiscus Iced Tea.",
            "KES": 540,
            "RectImageURL": HibiscusIcedTeaRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": blueLagoon,
            "Name": "Blue Lagoon",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with premium blue lagoon syrup, lemon juice and ice cubes garnished with mint leaves.",
            "KES": 540,
            "RectImageURL": blueLagoonRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": kiwiLemonade,
            "Name": "Kiwi Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with premium kiwi fruit mix, lemon juice and ice cubes garnished with mint leaves.",
            "KES": 540,
            "RectImageURL": kiwiLemonadeRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": strawberryLemonade,
            "Name": "Strawberry Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with premium strawberry fruit mix, lemon juice and ice cubes garnished with mint leaves.",
            "KES": 540,
            "RectImageURL": strawberryLemonadeRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": peachLemonade,
            "Name": "Peach Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with premium peach fruit mix, lemon juice and ice cubes garnished with mint leaves.",
            "KES": 540,
            "RectImageURL": peachLemonadeRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": classicLemonade,
            "Name": "Classic Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with premium peach fruit mix, lemon juice and ice cubes garnished with mint leaves.",
            "KES": 540,
            "RectImageURL": classicLemonadeRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": CucumberKiwiLemonade,
            "Name": "Cucumber Kiwi Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with premium kiwi fruit mix, cucumber, lemon juice and ice cubes garnished with mint leaves",
            "KES": 540,
            "RectImageURL": CucumberKiwiLemonaderect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": LavenderLemonade,
            "Name": "Lavender Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with lavender mix, lemon juice and ice cubes garnished with mint leaves",
            "KES": 540,
            "RectImageURL": LavenderLemonaderect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": StrawberrySunriseLemonade,
            "Name": "Strawberry Sunrise Lemonade",
            "category": "Handcrafted Lemonades",
            "dec": "Refreshing beverage with strawberry mix, lemon juice and ice cubes garnished with mint leaves.",
            "KES": 540,
            "RectImageURL": StrawberrySunriseLemonadeRect,
            "Upgrades": [
                { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": pinaColada,
            "Name": "Pina Colada",
            "category": "Coladas",
            "dec": "A smooth blend of premium coconut flavor, fresh pineapple juice, cream & crushed ice.",
            "KES": 540,
            "RectImageURL": pinaColadaRect,
            "Upgrades": [
                { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": strawberryColada,
            "Name": "Strawberry Colada",
            "category": "Coladas",
            "dec": "A smooth blend of premium strawberry mix, coconut flavor, fresh pineapple juice, cream & crushed ice.",
            "KES": 540,
            "RectImageURL": strawberryColadaRect,
            "Upgrades": [
                { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": passionColada,
            "Name": "Passion Colada",
            "category": "Coladas",
            "dec": "A smooth blend of premium passion mix, coconut flavor, fresh pineapple juice, cream & crushed ice.",
            "KES": 540,
            "RectImageURL": passionColadaRect,
            "Upgrades": [
                { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": peachColada,
            "Name": "Peach Colada",
            "category": "Coladas",
            "dec": "A smooth blend of premium peach mix, coconut flavor, fresh pineapple juice, cream & crushed ice.",
            "KES": 540,
            "RectImageURL": peachColadaRect,
            "Upgrades": [
                { name: "Add Whipped Cream", price: 100 }

            ]
          },
          {
            "ImageURL": ButterflyPea,
            "Name": "Butterfly Pea Colada",
            "category": "Coladas",
            "dec": "A smooth blend of lavender mix, coconut flavor, fresh pineapple juice, cream & crushed ice.",
            "KES": 540,
            "RectImageURL": ButterflyPeaRect,
            "Upgrades": [
                { name: "Add Whipped Cream", price: 100 }

            ]
          },
          
          // {
          //   "ImageURL": classicNojito,
          //   "Name": "Classic Nojito",
          //   "category": "Nojitos",
          //   "dec": "Refreshing beverage made with muddled lime wedges and fresh mint leaves with crushed ice, flavored with premium vanilla syrup.",
          //   "KES": 540,
          //   "RectImageURL": classicNojitoRect,
          //   "Upgrades": [
          //     { name: "Add Ginger", price: 100 }

          //   ]
          // },
          {
            "ImageURL": passionNojito,
            "Name": "Passion Nojito",
            "category": "Nojitos",
            "dec": "Refreshing beverage made with muddled lime wedges and fresh mint leaves with crushed ice, flavored with premium passion syrup.",
            "KES": 540,
            "RectImageURL": passionNojitoRect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": strawberryNojito,
            "Name": "Strawberry Nojito",
            "category": "Nojitos",
            "dec": "Refreshing beverage made with muddled lime wedges and fresh mint leaves with crushed ice, flavored with premium strawberry syrup.",
            "KES": 540,
            "RectImageURL": strawberryNojitoRect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": kiwiNojito,
            "Name": "Kiwi Nojito",
            "category": "Nojitos",
            "dec": "Refreshing beverage made with muddled lime wedges and fresh mint leaves with crushed ice, flavored with premium kiwi syrup.",
            "KES": 540,
            "RectImageURL": kiwiNojitoRect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },
          {
            "ImageURL": strawberryPeachPassionFuse,
            "Name": "Strawberry, Peach & Passion Fuse",
            "category": "Nojitos",
            "dec": "Strawberry, peach & passion fuse.",
            "KES": 540,
            "RectImageURL": strawberryPeachPassionFuseRect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },

          

          {
            "ImageURL": CucumberKiwiNojito,
            "Name": "Cucumber Kiwi Nojito",
            "category": "Nojitos",
            "dec": "Refreshing beverage made with muddled lime wedges and fresh mint leaves with crushed ice, flavored with premium cucumber & kiwi syrup.",
            "KES": 540,
            "RectImageURL": CucumberKiwiNojitorect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },
          // {
          //   "ImageURL": HibiscusNojito,
          //   "Name": "Hibiscus Nojito",
          //   "category": "Nojitos",
          //   "dec": "Refreshing beverage made with muddled lime wedges and fresh mint leaves with crushed ice, flavored with premium hibiscus syrup.",
          //   "KES": 540,
          //   "RectImageURL": HibiscusNojitoRect,
          //   "Upgrades": [
          //     { name: "Add Ginger", price: 100 }

          //   ]
          // },
          {
            "ImageURL": CocoLeBleuNojito,
            "Name": "Coco Le Bleu Nojito",
            "category": "Nojitos",
            "dec": "Coco le bleu",
            "KES": 540,
            "RectImageURL": CocoLeBleuNojitoRect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },
          // {
          //   "ImageURL": MintAquaCooler,
          //   "Name": "Mint Aqua Cooler",
          //   "category": "Nojitos",
          //   "dec": "Mint aqua cooler.",
          //   "KES": 540,
          //   "RectImageURL": MintAquaCoolerRect,
          //   "Upgrades": [
          //     { name: "Add Ginger", price: 100 }

          //   ]
          // },

          {
            "ImageURL": StrawberrySunriseNojito,
            "Name": "Strawberry Sunrise Nojito",
            "category": "Nojitos",
            "dec": "Strawberry sunrise nojito.",
            "KES": 540,
            "RectImageURL": StrawberrySunriseNojitoRect,
            "Upgrades": [
             { name: "Add Ginger", price: 100 }
            ]
          },


          {
            "ImageURL": LavenderNojito,
            "Name": "Lavender Nojito",
            "category": "Nojitos",
            "dec": "Lavender nojito.",
            "KES": 540,
            "RectImageURL": LavenderNojitoRect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },

          {
            "ImageURL": classicNojito1,
            "Name": "Classic Nojito",
            "category": "Nojitos",
            "dec": "Classic Nojito.",
            "KES": 540,
            "RectImageURL": classicNojito1Rect,
            "Upgrades": [
              { name: "Add Ginger", price: 100 }

            ]
          },

          


          {
            "ImageURL": hotChocolate,
            "Name": "Hot Chocolate",
            "category": "Hot Chocolate",
            "dec": "Rich dark chocolate with hot milk.",
            "KES": 360,
            "RectImageURL": hotChocolateRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },


          {
            "ImageURL": iceChocolate,
            "Name": "Ice Chocolate",
            "category": "Hot Chocolate",
            "dec": "Rich dark chocolate with Ice & milk.",
            "KES": 400,
            "RectImageURL": iceChocolateRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": africanTeaPot,
            "Name": "African Tea Pot",
            "category": "Hot Teas",
            "dec": "Brewed tea with milk.",
            "KES": 360,
            "RectImageURL": africanTeaPotRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": englishTea,
            "Name": "English Tea",
            "category": "Hot Teas",
            "dec": "Black tea with milk aside.",
            "KES": 360,
            "RectImageURL": englishTeaRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": blackTeaPot,
            "Name": "Black Tea Pot",
            "category": "Hot Teas",
            "dec": "Tea with hot water.",
            "KES": 360,
            "RectImageURL": blackTeaPotRect,
            "Upgrades": []
          },
          {
            "ImageURL": herbalTea,
            "Name": "Herbal Tea",
            "category": "Hot Teas",
            "dec": "Herbal tea of your choice: Peppermint | Chamomile | Green Tea | Earl Gray | Lemon Burst | English Breakfast.",
            "KES": 360,
            "RectImageURL": herbalTeaRect,
            "Upgrades": []
          },
          {
            "ImageURL": lemonTea,
            "Name": "Lemon Tea",
            "category": "Hot Teas",
            "dec": "Tea with fresh lemon.",
            "KES": 360,
            "RectImageURL": lemonTeaRect,
            "Upgrades": []
          },
          {
            "ImageURL": ButterflyPeaInfusionTea,
            "Name": "Butterfly Pea Infusion Tea",
            "category": "Hot Teas",
            "dec": "Butterfly Pea Infusion Tea.",
            "KES": 360,
            "RectImageURL": ButterflyPeaInfusionTearect,
            "Upgrades": []
          },
          {
            "ImageURL": HibiscusInfusionTea,
            "Name": "Hibiscus Infusion Tea",
            "category": "Hot Teas",
            "dec": "Hibiscus Infusion Tea.",
            "KES": 360,
            "RectImageURL": HibiscusInfusionTeaRect,
            "Upgrades": []
          },
          {
            "ImageURL": icedMocha,
            "Name": "Iced Cafe Mocha",
            "category": "Iced Mocha",
            "dec": "Espresso with chocolate and milk on ice.",
            "KES": 390,
            "RectImageURL": icedMochaRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": cafeAffogato,
            "Name": "Cafe Affogato",
            "category": "Iced Mocha",
            "dec": "Cafe Affogato.",
            "KES": 440,
            "RectImageURL": cafeAffogatoRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": icedCaramelMocha,
            "Name": "Iced Caramel Mocha",
            "category": "Iced Mocha",
            "dec": "Espresso with chocolate and milk, flavored with caramel syrup on ice.",
            "KES": 400,
            "RectImageURL": icedCaramelMochaRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": mocha,
            "Name": "Cafe Mocha",
            "category": "Mocha",
            "dec": "Espresso with chocolate and froth milk.",
            "KES": 370,
            "Single":370,
            "Double":400,
            "RectImageURL": mochaRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": caramelMocha,
            "Name": "Caramel Mocha",
            "category": "Mocha",
            "dec": "Espresso with chocolate and froth milk, flavored with caramel syrup.",
            "KES": 370,
            "Single":380,
            "Double":410,
            "RectImageURL": caramelMochaRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": mocha,
            "Name": "Cardamom & Ginger",
            "category": "Mocha",
            "dec": "Espresso with chocolate and froth milk flavored with cardamon & ginger",
            "KES": 370,
            "Single":380,
            "Double":410,
           
            "RectImageURL": mochaRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": icedLatte,
            "Name": "Iced Cafe Latte",
            "category": "Iced Latte",
            "dec": "Espresso with milk on ice.",
            "KES": 390,
            "RectImageURL": icecafelatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": icedLatte,
            "Name": "Iced Vanilla Latte",
            "category": "Iced Latte",
            "dec": "Espresso with milk on ice, flavored with vanilla syrup.",
            "KES": 400,
            "RectImageURL": icecafelatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": icedCaramelLatte,
            "Name": "Iced Caramel Latte",
            "category": "Iced Latte",
            "dec": "Espresso with milk on ice, flavored with caramel syrup.",
            "KES": 400,
            "RectImageURL": icedCaramelLatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },

          {
            "ImageURL": icedLatte,
            "Name": "Iced Spanish Latte",
            "category": "Iced Latte",
            "dec": "New iced spanish latte.",
            "KES": 400,
            "RectImageURL": icecafelatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": cafelatte1,
            "Name": "Cafe Latte",
            "category": "Latte",
            "dec": "Espresso with froth milk & less foam.",
            "KES": 320,
            "Single":320,
            "Double":360,
            "RectImageURL": cafelatte1,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": vanillaLatte,
            "Name": "Vanilla Latte",
            "category": "Latte",
            "dec": "Espresso with froth milk & less foam, flavored with vanilla syrup.",
            "KES": 340,
            "Single":340,
            "Double":400,
            "RectImageURL": vanillaLatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": caramelLatte,
            "Name": "Caramel Latte",
            "category": "Latte",
            "dec": "Espresso with froth milk & less foam, flavored with caramel syrup.",
            "KES": 340,
            "Single":340,
            "Double":400,
            "RectImageURL": caramelLatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": spanishLatte,
            "Name": "Spanish Latte",
            "category": "Latte",
            "dec": "New Spanish Latte.",
            "KES": 340,
            "Single":340,
            "Double":400,
            "RectImageURL": spanishLatteRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": cappuccino,
            "Name": "Cappuccino",
            "category": "Cappuccino",
            "dec": "Espresso with thick froth milk.",
            "KES": 300,
            "Single":300,
            "Double":340,
            "RectImageURL": cappuccinoRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": cardamonGinger,
            "Name": "Cardamon & Ginger",
            "category": "Cappuccino",
            "dec": "Espresso with thick froth milk spiced with cardamon & ginger.",
            "KES": 310,
            "Single":310,
            "Double":350,
            "RectImageURL": cardamonGingerRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": houseCoffee,
            "Name": "House Coffee",
            "category": "House Coffee",
            "dec": "Freshly brewed coffee.",
            "KES": 250,
            "RectImageURL": houseCoffeeRect,
            "Upgrades": [],
            "Single":0,
            "Double":0,
          },
          {
            "ImageURL": cortadoCoffee,
            "Name": "Cortado Coffee",
            "category": "House Coffee",
            "dec": "Cortado coffee.",
            "KES": 320,
            "RectImageURL": cortadoCoffeeRect,
           "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Substitute Milk with Camel Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ],
            "Single":0,
            "Double":0,
          },
          {
            "ImageURL": americano,
            "Name": "Americano",
            "category": "House Coffee",
            "dec": "Freshly brewed black coffee.",
            "KES": 250,
            "Single":250,
            "Double":270,
            "RectImageURL": americanoRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Substitute Milk with Camel Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": espresso,
            "Name": "Espresso",
            "category": "House Coffee",
            "dec": "Single shot of espresso.",
            "KES": 250,
            "Single":250,
            "Double":270,
            "RectImageURL": espressoRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Substitute Milk with Camel Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": macchiato,
            "Name": "Macchiato",
            "category": "House Coffee",
            "dec": "Single shot of espresso with froth milk.",
            "KES": 250,
            "Single":250,
            "Double":280,
            "RectImageURL": macchiatoRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Substitute Milk with Camel Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": icedCoffee,
            "Name": "Iced Coffee",
            "category": "House Coffee",
            "dec": "Coffee on ice.",
            "KES": 250,
            "Single":0,
            "Double":0,
            "RectImageURL": icedCoffeeRect,
            "Upgrades": [
              { name: "Substitute Milk with Soy Milk", price: 100 },
              { name: "Substitute Milk with Lactose Free Milk", price: 100 },
              { name: "Substitute Milk with Almond Milk", price: 100 },
              { name: "Substitute Milk with Camel Milk", price: 100 },
              { name: "Add Espresso", price: 100 }
            ]
          },
          {
            "ImageURL": kiddieMilkshake,
            "Name": "Kiddie MilkShake",
            "category": "Kiddie Drink",
            "dec": "Milkshakes of your choice of either vanilla, chocolate, strawberry, caramel or oreo.",
            "KES": 460,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieMilkshakeRect,
          },
          {
            "ImageURL": KiddieColada,
            "Name": "Kiddie Colada",
            "category": "Kiddie Drink",
            "dec": "Coladas of your choice - Pina Colada, strawberry, passion or peach.",
            "KES": 460,
            "Single":0,
            "Double":0,
            "RectImageURL": KiddieColadaRect,
          },
          {
            "ImageURL": KiddieFruitBooster,
            "Name": "Kiddie Fruit Boosters",
            "category": "Kiddie Drink",
            "dec": "Choice of Mango Madness or Aloha",
            "KES": 460,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieFruitBoosterRect,
          },
          {
            "ImageURL": kiddieJuice,
            "Name": "Kiddie Juices",
            "category": "Kiddie Drink",
            "dec": "Fresh juice of your choice of either passion, mango, pineapple, watermelon, carrot, cocktail, Pineapple Mint",
            "KES": 320,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieJuiceRect
          },
          {
            "ImageURL": kiddieOrangeJuice,
            "Name": "Kiddie Orange Juice",
            "category": "Kiddie Drink",
            "dec": "Fresh orange juice",
            "KES": 390,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieOrangeJuice
          },
          {
            "ImageURL": kiddieOrangeCarrotJuice,
            "Name": "Kiddie Orange Carrot Juice",
            "category": "Kiddie Drink",
            "dec": "Fresh orange carrot juice",
            "KES": 340,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieOrangeCarrotJuice
          },
          {
            "ImageURL": kiddieLemonade,
            "Name": "Kiddie Lemonades",
            "category": "Kiddie Drink",
            "dec": "Lemonades of your choice - Classic, Peach, Kiwi, Strawberry, Blue Lagoon.",
            "KES": 460,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieLemonadeRect,
          },
          {
            "ImageURL": kiddieNojito,
            "Name": "Kiddie Nojitos",
            "category": "Kiddie Drink",
            "dec": "Nojitos of your choice of either Passion, Strawberry, Kiwi, Strawberry Peach Fuse & Classic.",
            "KES": 460,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieNojitoRect,
          },
          {
            "ImageURL": kiddieIcedTea,
            "Name": "Kiddie Iced Teas",
            "category": "Kiddie Drink",
            "dec": "Choice of Strawberry, Peach, Kiwi, Passion or Berry Vanilla",
            "KES": 370,
            "Single":0,
            "Double":0,
            "RectImageURL": kiddieIcedTeaRect,
          }
    ]
}


export default PerfectedDrinks